// extracted by mini-css-extract-plugin
module.exports = {"numbers":"numbers-module--numbers--6x-qV","value":"numbers-module--value--30cSh","text":"numbers-module--text--31mcn"};